function init (){
  window.$(document).on('page:load', () => {
    const partners = document.getElementsByClassName('inline-partners')[0]
    if(partners && partners.children[0]){
      const randomPartner = partners.children[Math.floor(Math.random() * partners.children.length)]
      randomPartner.style.display = 'block'
    }
  })
}

export default init;
